module.exports = __webpack_public_path__ + "img/slide1_7.c042710c.png";